package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class AccountQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun count(): Query<Long> = Query(-111_842_240, arrayOf("account"), driver, "Account.sq",
      "count", "SELECT COUNT(*) FROM account") { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> getCurrent(mapper: (
    id: String,
    email: String,
    password_hash: String,
    salt: String,
    biometric_enrolled: Long,
    created_at: Long,
    last_login_at: Long?,
  ) -> T): Query<T> = Query(276_903_090, arrayOf("account"), driver, "Account.sq", "getCurrent",
      "SELECT account.id, account.email, account.password_hash, account.salt, account.biometric_enrolled, account.created_at, account.last_login_at FROM account LIMIT 1") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)
    )
  }

  public fun getCurrent(): Query<Account> = getCurrent { id, email, password_hash, salt,
      biometric_enrolled, created_at, last_login_at ->
    Account(
      id,
      email,
      password_hash,
      salt,
      biometric_enrolled,
      created_at,
      last_login_at
    )
  }

  public fun <T : Any> selectByEmail(email: String, mapper: (
    id: String,
    email: String,
    password_hash: String,
    salt: String,
    biometric_enrolled: Long,
    created_at: Long,
    last_login_at: Long?,
  ) -> T): Query<T> = SelectByEmailQuery(email) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)
    )
  }

  public fun selectByEmail(email: String): Query<Account> = selectByEmail(email) { id, email_,
      password_hash, salt, biometric_enrolled, created_at, last_login_at ->
    Account(
      id,
      email_,
      password_hash,
      salt,
      biometric_enrolled,
      created_at,
      last_login_at
    )
  }

  public fun insert(
    id: String,
    email: String,
    password_hash: String,
    salt: String,
    biometric_enrolled: Long,
    created_at: Long,
  ) {
    driver.execute(998_641_064, """
        |INSERT INTO account(id, email, password_hash, salt, biometric_enrolled, created_at)
        |VALUES (?, ?, ?, ?, ?, ?)
        """.trimMargin(), 6) {
          bindString(0, id)
          bindString(1, email)
          bindString(2, password_hash)
          bindString(3, salt)
          bindLong(4, biometric_enrolled)
          bindLong(5, created_at)
        }
    notifyQueries(998_641_064) { emit ->
      emit("account")
    }
  }

  public fun markBiometricEnrolled(id: String) {
    driver.execute(1_965_877_889, """UPDATE account SET biometric_enrolled = 1 WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(1_965_877_889) { emit ->
      emit("account")
    }
  }

  public fun updateLastLogin(last_login_at: Long?, id: String) {
    driver.execute(261_875_099, """UPDATE account SET last_login_at = ? WHERE id = ?""", 2) {
          bindLong(0, last_login_at)
          bindString(1, id)
        }
    notifyQueries(261_875_099) { emit ->
      emit("account")
    }
  }

  public fun updateCredentials(
    email: String,
    password_hash: String,
    salt: String,
    id: String,
  ) {
    driver.execute(616_317_988,
        """UPDATE account SET email = ?, password_hash = ?, salt = ?, biometric_enrolled = 1 WHERE id = ?""",
        4) {
          bindString(0, email)
          bindString(1, password_hash)
          bindString(2, salt)
          bindString(3, id)
        }
    notifyQueries(616_317_988) { emit ->
      emit("account")
    }
  }

  private inner class SelectByEmailQuery<out T : Any>(
    public val email: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("account", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("account", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_010_292_506,
        """SELECT account.id, account.email, account.password_hash, account.salt, account.biometric_enrolled, account.created_at, account.last_login_at FROM account WHERE email = ?""",
        mapper, 1) {
      bindString(0, email)
    }

    override fun toString(): String = "Account.sq:selectByEmail"
  }
}
